export function FixedMidpointRoundingToDown(num, decimalCount) {
  num = num * Math.pow(10, decimalCount);
  num = Math.floor(num);
  num = num / Math.pow(10, decimalCount);
  return num;
}

export function FixedMidpointRoundingToUp(num, decimalCount) {
  num = num * Math.pow(10, decimalCount);
  num = Math.ceil(num);
  num = num / Math.pow(10, decimalCount);
  return num;
}

export const formatPrice = (value) => {
  if (value) {
    const parts = value.toString().split(".");
    const firstPart = parts[0];
    const secondPart = parts[1];
    const formattedFirstPart = firstPart
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (secondPart) return `${formattedFirstPart}.${secondPart}`;
    else return formattedFirstPart;
  }
};

export const setStockNumberColor = (value) => {
  const isZero = value === 0;
  const isNegative = value < 0;
  const isPositive = value > 0;

  if (isZero)
    return {
      color: "text.main",
      sign: "",
    };

  if (isNegative)
    return {
      color: "error.main",
      sign: "",
    };

  if (isPositive)
    return {
      color: "success.main",
      sign: "+",
    };
};
